import { render } from "./scanBox.vue?vue&type=template&id=edc2d322&scoped=true"
import script from "./scanBox.vue?vue&type=script&lang=js"
export * from "./scanBox.vue?vue&type=script&lang=js"

import "./scanBox.vue?vue&type=style&index=0&id=edc2d322&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc2d322"]])

export default __exports__